module.exports = __webpack_public_path__ + "static/Q3_2025_Material_Differences_Report-90640d20d192281b4368d0ae48507da7.pdf";